<template>
    <div v-if="modalAlert" class="alert-modal toggle-alert">
        <div class="alert-modal-container">
            <div class="modal-content">
                <div id="alert-modal" class="card bg-orange-gradLight">

                    <button class="btn-close" @click="onClose">
                        <img :src="close" alt="close">
                    </button>

                    <div class="card-body">
                        <div class="mensages-container">
                            <img :src="warning" alt="warning" class="message-img">
                            <h1>Atenção!</h1>
                            <p v-if="isValentineDay">Todas as encomendas para o dia 14 devem ser através do site <a href="https://sushiathome.valentine.pt" target="_blank" style="color: #e8732a; text-decoration: underline; font-weight: bold;">sushiathome.valentine.pt</a></p>
                            <p v-else>Já não temos entregas disponíveis, mas podes pedir para outro dia.</p>

                            <div v-if="!isValentineDay" class="modal-bottom double">
                                <div class="text-center">
                                    <button class="btn-bg" @click="onClose">Confirmar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import icClose from '../../svg/ic_close_orange.svg'
import icWarning from '../../svg/ic_warning.svg'

export default {
    data() {
        return {
            close: icClose,
            warning: icWarning,
            modalAlert: false,
            isValentineDay: false,
        }
    },
    methods: {
        modalAlertHandler(date) {
            this.isValentineDay = this.checkIsValentineDay(date);
            this.modalAlert = !this.modalAlert;

            document.querySelector('html').classList.toggle('no-scroll');
            document.querySelector('body').classList.toggle('no-scroll');
        },
        checkIsValentineDay(date) {
            if (!date) return false;
            const d = new Date(date);
            return d.getMonth() === 1 && d.getDate() === 14;
        },
        onClose() {
            this.modalAlertHandler();
        }
    },
    created() {
        Livewire.on('slotsNotAvailable', (date) => this.modalAlertHandler(date));
    }
}
</script>

<style>

</style>
